export { WaitlistTerms } from './waitlist-terms.component';
